import { Message } from 'element-ui'
import router from '@/router'
import {
  isOrderStoreMismatchMsg,
  promptSwitchStoreForOrder,
} from '@/utils/orderStoreSwitch'

/** element-ui 运行时支持 closeAll，官方类型未声明 */
type MessageStatic = typeof Message & { closeAll?: () => void }

function closeAllMessages() {
  const m = Message as MessageStatic
  if (typeof m.closeAll === 'function') m.closeAll()
}

export { isOrderStoreMismatchMsg } from '@/utils/orderStoreSwitch'

/** 已处理：页面勿再 $message.error 原始文案 */
export const ORDER_STORE_HANDLED = '_orderStoreMismatchHandled'

let mismatchDialogTask: Promise<boolean> | null = null

export function isApiSuccess(code: any): boolean {
  return Number(code) === 1
}

export function shouldShowApiErrorMsg(data: any): boolean {
  if (!data) return true
  if (data[ORDER_STORE_HANDLED]) return false
  if (isOrderStoreMismatchMsg(data.msg)) return false
  return true
}

function parseRequestBody(data: any): Record<string, any> {
  if (!data) return {}
  if (typeof data === 'string') {
    try {
      return JSON.parse(data)
    } catch {
      return {}
    }
  }
  return data
}

function extractOrderIdFromConfig(config: any): string | number | null {
  if (!config) return null
  const body = parseRequestBody(config.data)
  if (body.id != null && body.id !== '') return body.id
  const params = config.params || {}
  if (params.id != null && params.id !== '') return params.id
  const url = String(config.url || '')
  const m = url.match(/\/order\/(?:delivery|complete|refund)\/(\d+)/i)
  if (m) return m[1]
  return null
}

/**
 * HTTP 200 + body.code=0 + msg 店铺不匹配 → 抑制 toast，弹窗切换店铺
 */
export async function handleOrderStoreMismatchResponse(
  response: any,
): Promise<boolean> {
  const data = response && response.data
  if (!data || isApiSuccess(data.code)) return false
  if (!isOrderStoreMismatchMsg(data.msg)) return false

  // 立刻标记，避免 .then 里重复 $message.error（HTTP 仍是 200）
  data[ORDER_STORE_HANDLED] = true
  closeAllMessages()

  const orderId = extractOrderIdFromConfig(response.config)
  if (orderId == null) {
    try {
      const { MessageBox } = await import('element-ui')
      await MessageBox.alert(
        '该订单不属于当前所选商户，请在顶栏「切换商户」中选择该订单所属店铺后重试。',
        '切换店铺',
        { type: 'warning', confirmButtonText: '知道了' },
      )
    } catch {
      /* cancel */
    }
    return true
  }

  if (!mismatchDialogTask) {
    mismatchDialogTask = promptSwitchStoreForOrder(orderId, router)
      .catch(() => false)
      .finally(() => {
        mismatchDialogTask = null
      })
  }

  return mismatchDialogTask
}
